module.exports = __webpack_public_path__ + "img/SeedIconS.7f16bce6.png";